import styled from 'styled-components'
import { Button } from 'antd'

const Btn = (props) => {
  const onClick = () => {
    let { name, onClick } = props
    if (onClick) onClick(name)
  }

  const { disabled, children, text, loading } = props

  let click
  if (!loading && !disabled) {
    click = onClick
  }
  return (
    <PageView>
      <Button disabled={disabled} loading={loading} onClick={click}>
        {children || text}
      </Button>
    </PageView>
  )
}

const PageView = styled.div`
  button {
    color: ${(p) => p.theme.color.green};
    border: 1px solid ${(p) => p.theme.color.green};
    background-color: white;
    width: 100%;
    height: 48px;
    border-radius: 5px;
    font-size: 16px;
  }

  button:hover,
  button:focus {
    color: ${(p) => p.theme.color.green};
    border: 1px solid ${(p) => p.theme.color.green};
    background-color: white;
  }
`

export default Btn
